import React from 'react';

import Layout from '../../components/layout';
import Category from '../../components/category-template';

export default ({ location: { pathname } }) => <Layout pathname={pathname}><Category category="car" title="Cars" /></Layout>;
